import { en } from "./translations.en";
import { cy } from "./translations.cy";

// Keyed by the same "language" values used elsewhere in the app
// ("english" / "welsh"), resolved to short dictionary codes here.
export const translations = { en, cy };

export { en, cy };
